module.exports = __webpack_public_path__ + "media/images/icon_blog-e1f2dcc99b68523769e839edd5794790.png";